import React from "react";

import Navbar from "../../components/Navbar";
import Footer from "../../components/Footer";

import "./event.css";

export default function Event() {
  return (
    <>
      <Navbar />
      <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 1440 150">
        <path
          fill="#D30032"
          fill-opacity="1"
          d="M0,128L60,122.7C120,117,240,107,360,90.7C480,75,600,53,720,48C840,43,960,53,1080,48C1200,43,1320,21,1380,10.7L1440,0L1440,0L1380,0C1320,0,1200,0,1080,0C960,0,840,0,720,0C600,0,480,0,360,0C240,0,120,0,60,0L0,0Z"
        ></path>
      </svg>
      <div className="mainContentEvent pb-5">
        <div className="container">
          <h1 className="text-center fw-bold text-danger pb-4">
            Event Organizer
          </h1>
          <div className="d-flex justify-content-around contentEvent">
            <div>
              <p className="descriptionEvent pe-lg-5 pe-md-3 fs-4">
                Kami akan bantu <span className="fw-bold"> REALISASIKAN </span>
                event impianmu, mulai dari pembuatan konsep sampai dengan
                hasilnya sesuai dengan keinginan anda.
              </p>
              <p className="descriptionEvent pe-lg-5 pe-md-3">
                3G Indonesia sebagai Event Organizer yang berpengalaman dan
                profesional akan membantu dan mensupport kebutuhan event sesuai
                dengan keinginan perusahaan anda. Baik event dalam skala
                personal maupun skala company.
              </p>
            </div>
            <div>
              <img
                src={require("../../assets/event-img.jpg")}
                alt="imageEvent"
                width={500}
              />
            </div>
          </div>
          <div className="d-flex justify-content-around py-lg-4 mainContentEventTwo">
            <img src={require("../../assets/evenOrg.png")} alt="event" />
            <div className="d-flex justify-content-around pt-md-3 fs-5">
              <ul>
                <h6 className="fw-bold">Skala personal :</h6>
                <li>Birthday Party</li>
                <li>Anniversary</li>
                <li>Garden Party</li>
              </ul>
              <ul>
                <h6 className="fw-bold">Skala company :</h6>
                <li>Grand Opening</li>
                <li>Family Gathering</li>
                <li>Gathering Employee</li>
                <li>Launching Product</li>
                <li>Annual Meeting</li>
                <li>Awarding</li>
                <li>Conference</li>
                <li>Seminar</li>
                <li>Workshop & Talkshow</li>
              </ul>
            </div>
          </div>
        </div>
      </div>
      <Footer />
    </>
  );
}
